<template>
    <div class="animated fadeIn">
        <Prank v-if="prank" />
        <b-card v-else>
            <b-form-checkbox v-model="allLabelSets" @change="(value) => { setAllLabelSets(labelSets, value) }">Export all label sets</b-form-checkbox>
            <b-form-checkbox v-model="allSampleSets" @change="(value) => { setAllSampleSets(labelSets, value) }">Export all sample sets</b-form-checkbox>
            <div class="check-grid">
                <div class="col-ls" data-toggle="tooltip" title="Label Sets">LS</div>
                <div class="col-ss" data-toggle="tooltip" title="Sample Sets">SS</div>
                <div class="col-desc" ></div>
                <template v-for="labelSet in labelSets" >
                    <div :key="`ls${labelSet.id}`"  class="col-ls" >
                        <b-form-checkbox v-model="exportLabelsets" :value="labelSet.id" @change="(value) => { if (value) { setChecked(labelSet.sample_sets, value) } }"/>
                    </div>
                    <div :key="`ss${labelSet.id}`"  class="col-ss" >
                        <b-form-checkbox
                            :checked="labelSet.sample_sets.filter((sid) => tSampleSets.includes(sid)).length === labelSet.sample_sets.length"
                            @change="(value) => setChecked(labelSet.sample_sets, value)"
                            :indeterminate="(
                              labelSet.sample_sets.filter(sid => !tSampleSets.includes(sid)).length > 0
                              && labelSet.sample_sets.filter(sid => tSampleSets.includes(sid)).length > 0
                              && labelSet.sample_sets.filter(sid => tSampleSets.includes(sid)).length !== labelSet.sample_sets.length
                            )" />
                    </div>
                    <div :key="`desc${labelSet.id}`"  class="col-desc">
                        {{ labelSet.name }}
                        <b-form-checkbox v-for="sampleSet in labelSet.sample_sets_data" :key="sampleSet.id"
                            :checked="tSampleSets.includes(sampleSet.id)"
                            @change="(value) => setChecked([sampleSet.id], value)">
                            {{ sampleSet.name }}
                        </b-form-checkbox>
                    </div>
                </template>
            </div>
            <b-button @click="exportProject(id)">Export</b-button>
            <b-button class="ml-2" @click="prank = true">Prank me</b-button>
        </b-card>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import Services from '@/services/index';
import Prank from './ProjectExportPrank.vue';

export default {
  mounted() {
    this.load();
  },
  data() {
    return {
      prank: false,
      includeSampleSets: 1,
      includeLabelSets: 1,
      labelSets: [],
      tSampleSets: [],
      exportLabelsets: [],
      allLabelSets: false,
      allSampleSets: false,
    };
  },
  components: {
    Prank
  },
  props: {
    id: { type: Number, default: null },
  },
  computed: {
    ...mapState('Auth', ['activeProjectId', 'token']),
  },
  methods: {
    load() {
      Services.labelSets.list(this.id, { notpagiate: true }).then(({ data }) => {
        this.labelSets = data.data;
      }).catch((err) => {
        if (err.code !== 'ERR_CANCELED') {
          // this.loading = false;
          console.log(err);
        }
      });
    },
    exportProject(projectId) {
      const params = new URLSearchParams({
        label_sets: [],
        sample_sets: [],
        token: this.token,
      });
      this.exportLabelsets.forEach((el) => {
        params.append('label_sets[]', el);
      });
      this.tSampleSets.forEach((el) => {
        params.append('sample_sets[]', el);
      });
      if (this.exportLabelsets > 0 || this.tSampleSets > 0) {
        window.location.href = `${window.location.origin}/api/projects/${projectId}/export?${params.toString()}`;
      }
    },
    setChecked(sampleSets, value) {
      if (value) {
        this.tSampleSets = [...new Set([...this.tSampleSets, ...sampleSets])];
      } else {
        this.tSampleSets = this.tSampleSets.filter((sid) => !sampleSets.includes(sid));
      }
    },
    setAllLabelSets(labelSets, value) {
      const labelSetId = [];
      labelSets.forEach((element) => {
        labelSetId.push(element.id);
      });
      if (value) {
        this.exportLabelsets = [...new Set([...this.exportLabelsets, ...labelSetId])];
      } else {
        this.exportLabelsets = [];
      }
    },
    setAllSampleSets(labelSets, value) {
      const sampleSetId = [];
      labelSets.forEach((element) => {
        element.sample_sets.forEach((el) => {
          sampleSetId.push(el);
        });
      });
      if (value) {
        this.tSampleSets = [...new Set([...this.tSampleSets, ...sampleSetId])];
      } else {
        this.tSampleSets = [];
      }
    }

  },

};
</script>
<style scoped>
.check-grid {
  display: grid;
  grid-template-columns: [ls] 30px [ss] 30px [desc] auto;
}

.col-ls {
  grid-column: ls;
}

.col-ss {
  grid-column: ss;
}

.col-desc {
  grid-column: desc;
}
</style>
